module.exports = __webpack_public_path__ + "img/edc-bank-mega.a95b4da5.png";